import { Schema } from '@core/data/dto/schema';

export const EmployeeLeaveBalanceSchema = {
    id: Schema.String,
    accrued: Schema.Number,
    accrued_ytd: Schema.Number,
    balance: Schema.Number,
    deducted: Schema.Number,
    status: Schema.Auto,
    timeoff_code: Schema.String,
    timeoff_name: Schema.String
}
